import { GzDashboardAppWebComponent } from './component/GzDashboardAppWebComponent';
import { WEB_COMPONENT_GZ_GENERIC_DASHBOARD_APP } from '../../webcomponents.constants';

window.customElements.define(WEB_COMPONENT_GZ_GENERIC_DASHBOARD_APP, GzDashboardAppWebComponent);

export { GzDashboardAppWebComponent };
